import { Container, Typography } from '@mui/material';
import React from 'react';

interface IfProps {
    condition: boolean;
    children: React.ReactNode;
    fallback?: React.ReactNode;
    loading?: boolean
}

export const If: React.FC<IfProps> = ({ condition, children, fallback, loading }) => {
    if (loading) {
        return  (
            <Container sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "800px", width: "100%" }}>
                <Typography sx={{ animation: "pulsate 3s ease-out" }} color="primary" fontSize="2rem">Loading...</Typography>
            </Container>
        )
    } 

    if (condition) {
        return <>{children}</>;
    } else {
        return <>{fallback}</>;
    }
};